<div class="fetal_medicine header_top">
    <div class="banner">
        <div class="container">
            <h6>Antenatal scans at NCare IVF</h6>
            <h2 class="visually-hidden">Fetal Medicine Scans at NCare IVF Center</h2>
            <h5>Precision at Every Stage of Pregnancy</h5>
            <p>At NCare IVF, we understand that every pregnancy is unique, and so is every scan. Our fetal
                medicine scans are designed to monitor the baby’s development with accuracy, care, and
                compassion. Using advanced imaging technology and protocols aligned with global fetal medicine
                guidelines, our scans help detect problems early, guide clinical decisions, and reassure expectant
                parents through each trimester.</p>
            <p>Whether you're in the early weeks of pregnancy or nearing delivery, we offer comprehensive scans
                tailored to your stage and clinical needs—performed by trained fetal medicine specialists in a calm,
                supportive environment.</p>
        </div>
    </div>
    <div class="fm_sec">
        <div class="container">
            <div class="accordion">
                <!-- 1. Amniocentesis -->
                <div class="accordion-item">
                    <input type="radio" name="accordion" id="amniocentesis" checked>
                    <label for="amniocentesis">1. Early Pregnancy Scan / Dating scan</label>
                    <div class="content">
                        <p><strong>What is it for?</strong><br>
                            To confirm location and number of pregnancy, detect the heartbeat, and rule out ectopic or
                            failed pregnancy.</p>

                        <p><strong>When is it done?</strong><br>
                            Usually between 6 and 9 weeks.</p>

                        <p><strong>Why is it important?</strong><br>
                            Provides early reassurance and confirms that the pregnancy is developing normally.<br>
                            Establishes a reliable due date, essential for scheduling all future tests and delivery
                            planning.</p>
                    </div>

                </div>

                <!-- 2. CVS -->
                <div class="accordion-item">
                    <input type="radio" name="accordion" id="cvs">
                    <label for="cvs">2. Nuchal Translucency (NT) Scan</label>
                    <div class="content">
                        <p><strong>When is it done?</strong><br>
                            Between 11 and 13+6 weeks.</p>

                        <p><strong>Why is it important?</strong><br>
                            Forms part of the first-trimester aneuploidy screening and can also suggest early structural
                            abnormalities.</p>
                    </div>

                </div>

                <!-- 3. Amnioreduction -->
                <div class="accordion-item">
                    <input type="radio" name="accordion" id="amnioreduction">
                    <label for="amnioreduction">3. Early Anomaly Scan</label>
                    <div class="content">
                        <p><strong>When is it done?</strong><br>
                            Between 16 and 18 weeks.</p>

                        <p><strong>Why is it important?</strong><br>
                            Useful for planning early interventions like amniocentesis in indicated cases. It helps
                            detect major structural abnormalities in the fetus earlier than the standard anomaly scan,
                            particularly in high-risk or IVF pregnancies.</p>
                    </div>

                </div>

                <!-- 4. Cordocentesis -->
                <div class="accordion-item">
                    <input type="radio" name="accordion" id="cordocentesis">
                    <label for="cordocentesis">4. Targeted Anomaly Scan</label>
                    <div class="content">
                        <p><strong>What is it for?</strong><br>
                            A comprehensive scan of the fetal structures like brain, spine, heart, limbs, and face to
                            detect congenital anomalies.</p>

                        <p><strong>When is it done?</strong><br>
                            Between 18 and 22 weeks.</p>

                        <p><strong>Why is it important?</strong><br>
                            It is the most critical mid-pregnancy scan for identifying structural abnormalities.</p>
                    </div>

                </div>

                <!-- 5. Multifetal Reduction -->
                <div class="accordion-item">
                    <input type="radio" name="accordion" id="multifetal">
                    <label for="multifetal">5. Genetic Sonogram</label>
                    <div class="content">
                        <p><strong>What is it for?</strong><br>
                            To assess for soft markers of chromosomal abnormalities like hypoplastic nasal bone,
                            ventriculomegaly, increased nuchal fold thickness, echogenic bowel, or short femur.</p>

                        <p><strong>When is it done?</strong><br>
                            Between 18 and 22 weeks, often as a follow-up to screening tests.</p>

                        <p><strong>Why is it important?</strong><br>
                            Offers additional information and helps to decide about further invasive testing like
                            amniocentesis in pregnant women with intermediate screening results.</p>
                    </div>

                </div>
                <div class="accordion-item">
                    <input type="radio" name="accordion" id="extended-anomaly">
                    <label for="extended-anomaly">6. 3D/4D/HD Extended Anomaly Survey</label>
                    <div class="content">
                        <p><strong>What is it for?</strong><br>
                            To provide enhanced views of the fetal face, limbs, and structures using 3D/4D technology.
                        </p>

                        <p><strong>When is it done?</strong><br>
                            Usually between 20 and 24 weeks.</p>

                        <p><strong>Why is it important?</strong><br>
                            Improves detection of subtle skeletal or facial anomalies and enhances parental bonding.</p>
                    </div>
                </div>
                <div class="accordion-item">
                    <input type="radio" name="accordion" id="fetal-echo">
                    <label for="fetal-echo">7. Fetal ECHO / Neurosonogram</label>
                    <div class="content">
                        <p><strong>What is a Fetal ECHO for?</strong><br>
                            To examine the fetal heart’s chambers, valves, and blood flow in detail.</p>

                        <p><strong>When is it done?</strong><br>
                            Between 18 and 24 weeks, or earlier in specific high-risk cases.</p>

                        <p><strong>Why is it important?</strong><br>
                            Allows early diagnosis of congenital heart defects, which can be life-saving.</p>

                        <p><strong>What is a Neurosonogram for?</strong><br>
                            To evaluate fetal brain structures and central nervous system development.</p>

                        <p><strong>When is it done?</strong><br>
                            Typically between 20 and 24 weeks.</p>

                        <p><strong>Why is it important?</strong><br>
                            Crucial for detecting ventriculomegaly, brain malformations, or complications like
                            hemorrhage.</p>
                    </div>
                </div>

                <div class="accordion-item">
                    <input type="radio" name="accordion" id="growth-scan">
                    <label for="growth-scan">8. Growth Scan with Doppler</label>
                    <div class="content">
                        <p><strong>What is it for?</strong><br>
                            To monitor fetal weight, fluid levels, and blood flow in the placenta and umbilical cord.
                        </p>

                        <p><strong>When is it done?</strong><br>
                            Usually from 28 weeks onwards.</p>

                        <p><strong>Why is it important?</strong><br>
                            Some congenital anomalies can evolve during the last trimester. This scan helps confirm the
                            absence of abnormalities and plan timely delivery in a tertiary care center when
                            needed.<br><br>
                            It also helps detect growth restrictions or placental insufficiency before symptoms appear.
                            These scans guide us in determining fetal well-being and the optimum time for delivery.</p>
                    </div>
                </div>


            </div>
        </div>
    </div>
    <section class="pink_bg_content mt-5">
        <div class="container">
            <div class="pink_bg_content_child">
                <h5>Not Sure Which Scan You Need? We’ll Guide You.</h5>
                <p>Whether you're early in pregnancy or monitoring your baby’s growth, our team will recommend the right
                    scan at the right time—based on your stage and clinical needs.</p>
                <button (click)="contactus()">Book an Appointment</button>
            </div>
        </div>
    </section>
    <div class="container">

        <div class="ncare-highlight">
            <h2>Because Every Scan Tells a Story</h2>
            <p>
                At NCare IVF, our fetal medicine scans do more than just monitor—they offer reassurance, insight,
                and the opportunity for early action. Each scan is performed with utmost care, supported by expert
                interpretation and personalized follow-up. Whether you’re confirming your pregnancy or preparing
                for delivery, we’re with you—every step of the way.
            </p>
        </div>
    </div>
</div>